import { Component, OnInit } from '@angular/core';

interface Section {
  title: string;
  icon: string;
  link: string;
}

@Component({
    selector: 'app-services',
    templateUrl: './services.component.html',
    styleUrls: ['./services.component.css'],
    standalone: false
})
export class ServicesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

sections: Section[] = [
  {
    title: 'Desarrollo comercial',
    icon: 'assets/svg/application.svg',
    link: '/servicios/desarrollo-comercial'
  },
  {
    title: 'UX & UI design',
    icon: 'assets/svg/puzzle.svg',
    link: '/servicios/ux-ui'
  },
  {
    title: 'Consultoria Tecnológica',
    icon: 'assets/svg/computer.svg',
    link: '/servicios/consultoria-tecnologica'
  },
  {
    title: 'Marketing digital',
    icon: 'assets/svg/social-media.svg',
    link: '/servicios/marketing-digital'
  },
  {
    title: 'Consultoría de IA',
    icon: 'assets/svg/brain.svg',
    link: '/servicios/consultoria-ia'
  }
];


}
